import { environment } from '@coverright/shared/config';

export const keycloakConfig = {
  url: environment.keycloakServer,
  realm: environment.keycloakRealm,
  protocol: 'openid-connect',
  clientId: environment.keycloakClientId,
}
